import React, { Component } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/pagination';

export class Portfolio extends Component {

    render() {

        return (

            // <!-- Case Study Start -->
            <div className="section techwix-case-study-section-02 section-padding" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/case-study-bg.jpg)` }}>
                <div className="container">
                    <div className="case-study-wrap">
                        <div className="section-title text-center">
                            <h3 className="sub-title">From our Case studies</h3>
                            <h2 className="title white">We delivered best solution</h2>
                        </div>
                    </div>
                </div>
                {/* <!-- Case Study Content Wrap Start --> */}
                <div className="case-study-content-wrap">
                    <div className="swiper-container case-study-active">
                        <Swiper
                            slidesPerView={3}
                            spaceBetween={30}                                 
                            centeredSlides={true}                                                        
                            loop={true}
                            autoplay={{
                                delay:1000
                            }}    
                            pagination={{
                                      el: ".case-study-active .swiper-pagination",
                                      clickable: true,
                             }}
                            modules={[Pagination, Autoplay]}                                               
                          
                            breakpoints={{
                                0: {
                                    slidesPerView: 1
                                },
                                576: {
                                    slidesPerView: 1
                                },
                                768: {
                                    slidesPerView: 1
                                },
                                992: {
                                    slidesPerView: 2
                                },
                                1200: {
                                    slidesPerView: 3
                                }
                            }}
                        >

                            {
                                this.props.ourwork ?
                                    this.props.ourwork.map((item, i) =>
                                        <SwiperSlide key={i}>
                                            <div className="single-case-study-02">
                                                <div className="case-study-img">
                                                    <img src={item.our_work_image.toString()} alt="" />
                                                </div>                                                
                                            </div>
                                        </SwiperSlide>                                        
                                    )
                                    : ''
                            }
                                        
                        </Swiper>

                        {/* <!-- Add Pagination --> */}
                        <div className="swiper-pagination"></div>
                    </div>
                </div>
                {/* <!-- Case Study Content Wrap End --> */}
            </div>
            // <!-- Case Study End --> 

        )
    }
}

export default Portfolio